import React, { useState, useEffect } from 'react';
import {
  Card,
  Select,
  Button,
  Space,
  message,
  Spin,
  Typography,
  Row,
  Col,
  Alert,
  Tag,
  Input,
  Progress
} from 'antd';
import {
  TranslationOutlined,
  CopyOutlined,
  ClearOutlined,
  FileTextOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { axiosPost } from '../../services/http.services';
import {API_FETCH_AUDIO_FILES} from '../../api/api';

const { Option } = Select;
const { Title, Text } = Typography;
const { TextArea } = Input;

const API_KEY = "XgjWkGf-1cm1bDB5lHQfJGYYmd6HOPAyoOn6T6m3ibvq5NAbBr8PAEnvBAFZW3Fg";

const SUPPORTED_LANGUAGES = [
  { code: "hi", name: "Hindi", nativeName: "हिंदी", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "ta", name: "Tamil", nativeName: "தமிழ்", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "bn", name: "Bangali", nativeName: "বাংলা", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "mr", name: "Marathi", nativeName: "मराठी", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "te", name: "Telugu", nativeName: "తెలుగు", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "as", name: "Assamese", nativeName: "অসমীয়া", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "ml", name: "Malayalam", nativeName: "മലയാളം", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "or", name: "Odia", nativeName: "ଓଡିଆ", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ", serviceId: "bhashini/iiith/nmt-all" },
  { code: "brx", name: "Bodo", nativeName: "Bodo", serviceId: "bhashini/iiith/nmt-all" },
  { code: "sd", name: "Sindhi", nativeName: "Sindhi", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "ne", name: "Nepali", nativeName: "नेपाली", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "sa", name: "Sanskrit", nativeName: "संस्कृतम्", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "ur", name: "Urdu", nativeName: "اردو", serviceId: "bhashini/iiith/nmt-all" },
  { code: "mni", name: "Manipuri", nativeName: "Manipuri", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "doi", name: "Dogri", nativeName: "Dogri", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "sat", name: "Santali", nativeName: "Santali", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "mai", name: "Maithili", nativeName: "मैथिली", serviceId: "bhashini/iiith/nmt-all" },
  { code: "kok", name: "Konkani", nativeName: "कोंकणी", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" },
  { code: "ks", name: "Kashmiri", nativeName: "कश्मीरी", serviceId: "ai4bharat/indictrans-v2-all-gpu--t4" }
];

const CHUNK_SIZE_OPTIONS = [10, 15, 20, 30, 50];

const BhashiniService = () => {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [language, setLanguage] = useState("hi");
  const [excludedKeys, setExcludedKeys] = useState("DISCLAIMER_TEXT, bhashini, BP_SHARING_FOOTER_DESC, WALLET_FOOTER_DESC, MENU_FOOTER_DESC, PREVIOUS_TRIPS_FOOTER_DESC");
  const [chunkSize, setChunkSize] = useState(50);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [translationStats, setTranslationStats] = useState(null);
  const [translationHistory, setTranslationHistory] = useState([]);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const [isProcessing, setIsProcessing] = useState(false);

  // const CONSENT_TEXTS = [{"key":"vc_header","value":"వినియోగదారు సమ్మతి-వెరిఫయబుల్ ధృవీకరణ సృష్టి"},{"key":"uidai_guardian_consent","value":"UIDAI నుండి ఈ క్రింది సమాచారాన్ని పొందడానికి నేను డిజి యాత్ర ఫౌండేషన్కు నా సమ్మతిని అందిస్తున్నాను."},{"key":"digilocker_guardian_consent","value":"DigiLocker నుండి ఈ క్రింది సమాచారాన్ని పొందడానికి నేను డిజి యాత్ర ఫౌండేషన్కు నా సమ్మతిని అందిస్తున్నాను."},{"key":"credential_minor_consent","value":"వర్తించే చట్టాల ప్రకారం నేను మైనర్కు చట్టపరమైన సంరక్షకుడిని అని వెరిఫయబుల్ అందువల్ల డిజి యాత్ర వెరిఫైబుల్ క్రెడెన్షియల్ (విసి) ను రూపొందించడానికి మైనర్ యొక్క ఈ క్రింది డాటాను పొందటానికి డిజి యాత్ర ఫౌండేషన్ ఫౌండేషన్కు సమ్మతి ఇవ్వండిః"},{"key":"guardian_full_consent","value":"డాటా వినియోగదారు. డిజి యాత్ర ఫౌండేషన్. డాటా. పేరు, పుట్టిన తేదీ, లింగం, గుర్తింపు పత్రం నంబర్ గడువు తేదీ మరియు ముఖ చిత్రం. ఉద్దేశం. విజయవంతమైన సరిపోలికపై డిజి యాత్ర వెరిఫైబుల్ క్రెడెన్షియల్ (విసి) ను రూపొందించడానికి ఐడెంటిటీ డాక్యుమెంట్ చిత్రం మరియు సెల్ఫీ చిత్రాన్ని సరిపోల్చడం కోసం మాత్రమే. వ్యవధి. డిజి యాత్ర అప్ తొలగించబడే వరకు లేదా అన్ఇన్స్టాల్ చేసే వరకు డిజి యాత్ర విసి మీ ఫోన్ యొక్క డిజి యాత్ర వాలెట్లో స్థానికంగా సేవ్ చేయబడుతుంది. డిజి యాత్ర సర్వర్లలో ఏ డాటా కేంద్రంగా నిల్వ చేయబడదు. నేను అంగీకరిస్తున్నాను మరియు ధృవీకరిస్తున్నానుగోప్యతా విధానండిజి యాత్ర వెబ్సైట్లో అందుబాటులో ఉంది. "},{"key":"minor_full_consent","value":"డాటా వినియోగదారు. డిజి యాత్ర ఫౌండేషన్. డాటా. పేరు, పుట్టిన తేదీ, లింగం, గుర్తింపు పత్రం నంబర్ గడువు తేదీ మరియు ముఖ చిత్రం. ఉద్దేశం. విజయవంతమైన సరిపోలికపై డిజి యాత్ర వెరిఫైబుల్ క్రెడెన్షియల్ (విసి) ను రూపొందించడానికి ఐడెంటిటీ డాక్యుమెంట్ చిత్రం మరియు సెల్ఫీ చిత్రాన్ని సరిపోల్చడం కోసం మాత్రమే. వ్యవధి. డిజి యాత్ర అప్ యొక్క చిన్న లేదా అన్ఇన్స్టాలేషన్ తరపున తొలగించబడే వరకు డిజి యాత్ర విసి మీ ఫోన్ యొక్క డిజి యాత్ర వాలెట్లో స్థానికంగా సేవ్ చేయబడుతుంది. డిజి యాత్ర సర్వర్లలో ఏ డాటా కేంద్రంగా నిల్వ చేయబడదు. నేను అంగీకరిస్తున్నాను మరియు ధృవీకరిస్తున్నానుగోప్యతా విధానండిజి యాత్ర వెబ్సైట్లో అందుబాటులో ఉంది. "},{"key":"dl_consent_url","value":"డాటా వినియోగదారు. డిజి యాత్ర ఫౌండేషన్. డాటా. పేరు, పుట్టిన తేదీ, లింగం, గుర్తింపు పత్రం నంబర్ గడువు తేదీ మరియు ముఖ చిత్రం. ఉద్దేశం. విజయవంతమైన సరిపోలికపై డిజి యాత్ర వెరిఫైబుల్ క్రెడెన్షియల్ (విసి) ను రూపొందించడానికి ఐడెంటిటీ డాక్యుమెంట్ చిత్రం మరియు సెల్ఫీ చిత్రాన్ని సరిపోల్చడం కోసం మాత్రమే. వ్యవధి. డిజి యాత్ర అప్ తొలగించబడే వరకు లేదా అన్ఇన్స్టాల్ చేసే వరకు డిజి యాత్ర విసి మీ ఫోన్ యొక్క డిజి యాత్ర వాలెట్లో స్థానికంగా సేవ్ చేయబడుతుంది. డిజి యాత్ర సర్వర్లలో ఏ డాటా కేంద్రంగా నిల్వ చేయబడదు. నేను అంగీకరిస్తున్నాను మరియు ధృవీకరిస్తున్నానుగోప్యతా విధానండిజి యాత్ర వెబ్సైట్లో అందుబాటులో ఉంది. "},{"key":"boarding_pass_consent","value":"వినియోగదారు సమ్మతి-వీసీ మరియు బోర్డింగ్ పాస్ షేరింగ్. తదుపరి తెరపై, దిగువ డాటాను అప్లోడ్ చేయడానికి మరియు ఒరిజిన్ ఎయిర్పోర్ట్తో పంచుకోవడానికి ఎంపికలలో ఒకదాన్ని ఎంచుకోండి. డాటా వినియోగదారు. డిజి యాత్ర ఫౌండేషన్ మరియు ఆరిజిన్ ఎయిర్పోర్ట్. డాటా. ప్రయాణ వివరాలు (పేరు, పిఎన్ఆర్, సీట్ #, ఫ్లైట్ #, ఒరిజిన్, డెస్టినేషన్ ప్రయాణ తేదీ, సీక్వెన్స్ #) మరియు డిజి యాత్ర విసి, ఇందులో సెల్ఫీ చిత్రం, గుర్తింపు పత్రం ప్రకారం పేరు, డిఓబి, లింగం మరియు ముసుగు గుర్తింపు పత్రం #ఉంటాయి. ఉద్దేశం. ప్రవేశం నుండి బోర్డింగ్ వరకు ఒరిజిన్ ఎయిర్పోర్ట్ తనిఖీ కేంద్రాల వద్ద గుర్తింపు మరియు ప్రయాణ పత్ర ధృవీకరణ ప్రయోజనం కోసం మాత్రమే డాటా ఉపయోగించబడుతుంది. వ్యవధి. మీ విమానం టేకాఫ్ అయినప్పటి నుండి 24 గంటల వరకు డాటా ఒరిజిన్ ఎయిర్పోర్ట్లో ఉంటుంది మరియు హిస్టరీ నుండి తొలగించబడే వరకు లేదా డిజి యాత్ర అప్ను అన్ఇన్స్టాల్ చేసే వరకు మీ ఫోన్లోని డిజి యాత్ర వాలెట్లో స్థానికంగా సేవ్ చేయబడుతుంది. డిజి యాత్ర సర్వర్లలో ఏ డాటా కేంద్రంగా నిల్వ చేయబడదు. నేను అంగీకరిస్తున్నాను మరియు ధృవీకరిస్తున్నాను గోప్యతా విధానం డిజి యాత్ర వెబ్సైట్లో అందుబాటులో ఉంది. "}]

  useEffect(() => {
    loadTranslationHistory();
    // fetchAudioFile();
  }, []);

  const loadTranslationHistory = () => {
    const stored = translationHistory;
    setTranslationHistory(stored);
  };

  const saveToHistory = (translation) => {
    try {
      const newHistory = [
        {
          id: Date.now(),
          timestamp: new Date().toISOString(),
          sourceLanguage: "en",
          targetLanguage: language,
          inputText: inputText.substring(0, 100) + (inputText.length > 100 ? '...' : ''),
          success: true,
          keyCount: Object.keys(JSON.parse(inputText)).length
        },
        ...translationHistory.slice(0, 9)
      ];

      setTranslationHistory(newHistory);
    } catch (error) {
      console.error('Error saving to history:', error);
    }
  };

  const createChunks = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const extractTrailingDots = (text) => {
    const match = text.match(/^(.*?)(\.{2,})$/);
    if (match) {
      return {
        content: match[1],
        dots: match[2]
      };
    }
    return { content: text, dots: '' };
  };

  const extractPlaceholders = (text) => {
    const placeholders = [];
    let modifiedText = text;
  
    const placeholderPattern = /\{\{([^}]+)\}\}/g;
    const matches = [...text.matchAll(placeholderPattern)];
  
    matches.forEach((match, index) => {
      const fullPlaceholder = match[0];
      const innerContent = match[1].trim();
  
      placeholders.push({
        index: index,
        original: fullPlaceholder,
        innerContent: innerContent
      });
    });
  
    return { modifiedText, placeholders };
  };
  
  const restorePlaceholders = (translatedText, placeholders) => {
    let restoredText = translatedText;
  
    placeholders.slice().reverse().forEach(({ original, innerContent }) => {
      const regex = /(.*?)({{[^{}]*?}}?)(.*)/;
      const match = restoredText.match(regex);

      if (match) {
        const part1 = match[1].trim(); 
        const part2 = match[2].trim();
        const part3 = match[3].trim();
      
        const finalString = `${part1} ${original} ${part3}`.trim().replace(/\s+/g, ' ');
       
        restoredText = finalString;
      }
    });

    if(restoredText.includes('customlink')){
      restoredText = restoredText.replace(/customlink/gi, 'CustomLink');
      restoredText = restoredText
      .replace(/<CustomLink>/g, ' <CustomLink>')
      .replace(/<\/CustomLink>/g, '</CustomLink> ');
    }
  
    return restoredText;
  };

  // const fetchAudioFile = async () => {
  //   const values = {data: CONSENT_TEXTS, languageCode: 'te'}
  //   const res = await axiosPost(API_FETCH_AUDIO_FILES, values);

  //   console.log('hii Audio file response:', res);
  // }

  const fetchBhashiniTranslation = async (textsToTranslate, targetLang,bhashiniServiceId) => {
    try {
      const response = await fetch(
        "https://dhruva-api.bhashini.gov.in/services/inference/pipeline",
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: API_KEY,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pipelineTasks: [
              {
                taskType: "translation",
                config: {
                  language: {
                    sourceLanguage: "en",
                    targetLanguage: targetLang,
                  },
                  serviceId: bhashiniServiceId,
                  preProcessors:["html"],
                  postProcessors: ["glossary"],
                },
              },
            ],
            inputData: {
              input: textsToTranslate.map((txt) => ({ source: txt })),
            },
          })
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const data = await response.json();

      if (!data?.pipelineResponse?.[0]?.output) {
        throw new Error('Invalid response structure from Bhashini API');
      }

      const translatedTexts = data.pipelineResponse[0].output.map(
        (item) => item.target
      );

      return translatedTexts;
    } catch (error) {
      console.error("Bhashini API fetch error:", error);
      throw error;
    }
  };

  const validateJSON = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        throw new Error('Input must be a valid JSON object');
      }
      return parsed;
    } catch (error) {
      throw new Error('Invalid JSON format. Please check your input.');
    }
  };

  const parseExcludedKeys = () => {
    if (!excludedKeys.trim()) return [];
    
    return excludedKeys
      .split(',')
      .map(key => key.trim())
      .filter(key => key.length > 0);
  };

  const handleTranslate = async () => {
    if (!inputText.trim()) {
      message.warning('Please enter JSON text to translate');
      return;
    }

    setLoading(true);
    setIsProcessing(true);
    setError(null);
    setOutputText("");
    setTranslationStats(null);
    setProgress({ current: 0, total: 0 });

    try {
      const startTime = Date.now();

      const parsedInput = validateJSON(inputText);
      const entries = Object.entries(parsedInput);
      
      if (entries.length === 0) {
        throw new Error('JSON object is empty');
      }

      const excludedKeysList = parseExcludedKeys();

      const translatableEntries = entries.filter(([key, value]) => 
        typeof value === 'string' && 
        value.trim() !== '' && 
        !excludedKeysList.includes(key)
      );

      const excludedEntries = entries.filter(([key, value]) =>
        typeof value === 'string' && 
        value.trim() !== '' && 
        excludedKeysList.includes(key)
      );

      if (translatableEntries.length === 0) {
        throw new Error('No translatable text found in JSON (all keys may be excluded)');
      }

      const preprocessedData = translatableEntries.map(([key, value]) => {
        const { content, dots } = extractTrailingDots(value);
        const { modifiedText, placeholders } = extractPlaceholders(content);
        
        return {
          key,
          originalValue: value,
          dotsInfo: { content, dots },
          placeholdersInfo: { modifiedText, placeholders },
          textForTranslation: modifiedText
        };
      });

      const textsForTranslation = preprocessedData.map(item => item.textForTranslation);
      
      const chunks = createChunks(textsForTranslation, chunkSize);
      setProgress({ current: 0, total: chunks.length });

      let allTranslations = [];
      const translatedJSON = {};
      const lang = SUPPORTED_LANGUAGES.find(item => item.code === language);

      for (let i = 0; i < chunks.length; i++) {
        try {
          const chunkTranslations = await fetchBhashiniTranslation(chunks[i], language,lang.serviceId);
          allTranslations = [...allTranslations, ...chunkTranslations];
          
          setProgress({ current: i + 1, total: chunks.length });

          const partialJSON = {};
          
          for (let j = 0; j < allTranslations.length; j++) {
            const item = preprocessedData[j];
            let translatedText = allTranslations[j];
            
            translatedText = restorePlaceholders(translatedText, item.placeholdersInfo.placeholders);
            
            if (item.dotsInfo.dots) {
              translatedText = translatedText + item.dotsInfo.dots;
            }
            
            partialJSON[item.key] = translatedText;
          }

          setOutputText(JSON.stringify(partialJSON, null, 2));
          
          if (i < chunks.length - 1) {
            await delay(1000);
          }
        } catch (chunkError) {
          console.error(`Error in chunk ${i + 1}:`, chunkError);
          throw new Error(`Translation failed at chunk ${i + 1}: ${chunkError.message}`);
        }
      }

      const finalTranslations = preprocessedData.map((item, index) => {
        let translatedText = allTranslations[index] || item.textForTranslation;
        
        translatedText = restorePlaceholders(translatedText, item.placeholdersInfo.placeholders);
        
        if (item.dotsInfo.dots) {
          translatedText = translatedText + item.dotsInfo.dots;
        }
        
        return {
          key: item.key,
          translatedValue: translatedText
        };
      });

      const finalJSON = {};
      let translationIndex = 0;

      entries.forEach(([key, value]) => {
        if (excludedKeysList.includes(key)) {
          finalJSON[key] = value;
        } else if (typeof value === 'string' && value.trim() !== '') {
          finalJSON[key] = finalTranslations[translationIndex].translatedValue;
          translationIndex++;
        } else {
          finalJSON[key] = value;
        }
      });

      const endTime = Date.now();
      const translationTime = endTime - startTime;

      setOutputText(JSON.stringify(finalJSON, null, 2));
      setTranslationStats({
        totalKeys: entries.length,
        translatedKeys: translatableEntries.length,
        excludedKeys: excludedEntries.length,
        translationTime: translationTime,
        targetLanguage: language,
        sourceLanguage: 'en',
        chunksProcessed: chunks.length,
        chunkSize: chunkSize,
        placeholdersFound: preprocessedData.reduce((acc, item) => acc + item.placeholdersInfo.placeholders.length, 0),
        dotsPreserved: preprocessedData.filter(item => item.dotsInfo.dots).length
      });

      saveToHistory(finalJSON);

      message.success(
        `Translation completed! Translated ${translatableEntries.length} fields, excluded ${excludedEntries.length} fields.`
      );

    } catch (error) {
      console.error("Translation Error:", error);
      setError(error.message || "Translation failed. Please try again.");
      message.error(error.message || "Translation failed");
    } finally {
      setLoading(false);
      setIsProcessing(false);
      setProgress({ current: 0, total: 0 });
    }
  };

  const handleAutoTranslateAll = async () => {
    if (!inputText.trim()) {
      message.warning('Please enter JSON text to translate');
      return;
    }
  
    setLoading(true);
    setIsProcessing(true);
    setError(null);
    setOutputText("");
    setTranslationStats(null);
    setProgress({ current: 0, total: 0 });
  
    try {
      const parsedInput = validateJSON(inputText);
      const entries = Object.entries(parsedInput);
      if (entries.length === 0) {
        throw new Error('JSON object is empty');
      }
  
      const excludedKeysList = parseExcludedKeys();
  
      for (let langIndex = 0; langIndex < SUPPORTED_LANGUAGES.length; langIndex++) {
        const currentLang = SUPPORTED_LANGUAGES[langIndex];
        setLanguage(currentLang.code);
        message.info(`Translating to ${currentLang.name} (${currentLang.nativeName})...`);
  
        const translatableEntries = entries.filter(([key, value]) =>
          typeof value === 'string' &&
          value.trim() !== '' &&
          !excludedKeysList.includes(key)
        );
  
        const preprocessedData = translatableEntries.map(([key, value]) => {
          const { content, dots } = extractTrailingDots(value);
          const { modifiedText, placeholders } = extractPlaceholders(content);
          return {
            key,
            originalValue: value,
            dotsInfo: { content, dots },
            placeholdersInfo: { modifiedText, placeholders },
            textForTranslation: modifiedText
          };
        });
  
        const textsForTranslation = preprocessedData.map(item => item.textForTranslation);
        const chunks = createChunks(textsForTranslation, chunkSize);
        setProgress({ current: 0, total: chunks.length });
  
        let allTranslations = [];
  
        for (let i = 0; i < chunks.length; i++) {
          const chunkTranslations = await fetchBhashiniTranslation(chunks[i], currentLang.code,currentLang.serviceId);
          allTranslations = [...allTranslations, ...chunkTranslations];
          setProgress({ current: i + 1, total: chunks.length });
          setOutputText(`Translating ${currentLang.name}... (${i + 1}/${chunks.length} chunks)`);
  
          if (i < chunks.length - 1) {
            await delay(1000);
          }
        }
  
        const finalJSON = {};
        let translationIndex = 0;
        entries.forEach(([key, value]) => {
          if (excludedKeysList.includes(key)) {
            finalJSON[key] = value;
          } else if (typeof value === 'string' && value.trim() !== '') {
            let translatedText = allTranslations[translationIndex];
            const item = preprocessedData[translationIndex];
            translatedText = restorePlaceholders(translatedText, item.placeholdersInfo.placeholders);
            if (item.dotsInfo.dots) translatedText += item.dotsInfo.dots;
            finalJSON[key] = translatedText;
            translationIndex++;
          } else {
            finalJSON[key] = value;
          }
        });
  
        // Export file for current language
        const outputJSON = JSON.stringify(finalJSON, null, 2);
        const blob = new Blob([outputJSON], { type: 'application/json' });
        const fileName = `${currentLang.name.toLowerCase()}.json`;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
  
        message.success(`✅ Exported ${fileName}`);
  
        await delay(1500);
      }
  
      message.success("🎉 All languages translated and exported successfully!");
  
    } catch (error) {
      console.error("Auto translation error:", error);
      setError(error.message || "Automation failed");
      message.error(error.message || "Automation failed");
    } finally {
      setLoading(false);
      setIsProcessing(false);
      setProgress({ current: 0, total: 0 });
    }
  };

  const handleCopy = async () => {
    if (!outputText) {
      message.warning('No output to copy');
      return;
    }

    try {
      await navigator.clipboard.writeText(outputText);
      message.success('Output copied to clipboard!');
    } catch (error) {
      console.error('Copy error:', error);
      message.error('Failed to copy to clipboard');
    }
  };

  const handleExport = () => {
    if (!outputText) {
      message.warning('No output to export');
      return;
    }

    if (isProcessing) {
      message.warning('Please wait until all chunks are processed');
      return;
    }

    try {
      const selectedLanguage = SUPPORTED_LANGUAGES.find(lang => lang.code === language);
      const fileName = `${selectedLanguage?.name?.toLowerCase() || language}.json`;
      
      const blob = new Blob([outputText], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      URL.revokeObjectURL(url);
      message.success(`File exported as ${fileName}`);
    } catch (error) {
      console.error('Export error:', error);
      message.error('Failed to export file');
    }
  };

  const handleClear = () => {
    setInputText("");
    setOutputText("");
    setExcludedKeys("");
    setError(null);
    setTranslationStats(null);
    setProgress({ current: 0, total: 0 });
    message.success('Form cleared successfully!');
  };

  const clearHistory = () => {
    setTranslationHistory([]);
    message.success('Translation history cleared!');
  };

  const selectedLanguage = SUPPORTED_LANGUAGES.find(lang => lang.code === language);

  return (
    <div style={{ padding: '24px', background: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Title level={2} style={{ marginBottom: '8px', fontSize: '32px' }}>
            <GlobalOutlined style={{ marginRight: '12px' }} />
            Bhashini Translation Service
          </Title>
          <Text type="secondary">
            Enhanced with placeholder preservation and key exclusion
          </Text>
        </div>

        {translationHistory.length > 0 && (
          <Card 
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Text strong>Recent Translations</Text>
                <Button 
                  size="small" 
                  danger 
                  icon={<ClearOutlined />} 
                  onClick={clearHistory}
                >
                  Clear History
                </Button>
              </div>
            }
            style={{ marginBottom: '24px' }}
            bodyStyle={{ padding: '16px' }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {translationHistory.slice(0, 5).map((item) => (
                <Tag 
                  key={item.id}
                  color="blue" 
                  style={{ marginBottom: '4px' }}
                >
                  {SUPPORTED_LANGUAGES.find(l => l.code === item.targetLanguage)?.name} - {item.keyCount} keys
                  <Text type="secondary" style={{ fontSize: '11px', marginLeft: '4px' }}>
                    ({new Date(item.timestamp).toLocaleDateString()})
                  </Text>
                </Tag>
              ))}
            </div>
          </Card>
        )}

        {loading && progress.total > 0 && (
          <Card style={{ marginBottom: '24px' }}>
            <div style={{ textAlign: 'center' }}>
              <Text strong>Processing Translation Chunks</Text>
              <Progress 
                percent={Math.round((progress.current / progress.total) * 100)}
                format={() => `${progress.current}/${progress.total} chunks`}
                style={{ marginTop: '8px' }}
                status={isProcessing ? "active" : "success"}
              />
              <div style={{ marginTop: '8px' }}>
                <Text type="secondary">
                  {isProcessing ? 'Translation in progress... Partial results shown below' : 'Translation complete!'}
                </Text>
              </div>
            </div>
          </Card>
        )}

        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          justifyContent: 'center', 
          alignItems: 'center', 
          gap: '12px',
          marginBottom: '24px',
          padding: '12px 16px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
        }}>
          <Select
            value={language}
            onChange={setLanguage}
            size="large"
            style={{ minWidth: 220 }}
            disabled={loading}
          >
            {SUPPORTED_LANGUAGES.map((lang) => (
              <Option key={lang.code} value={lang.code}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{lang.name}</span>
                  <Text type="secondary" style={{ fontSize: '12px' }}>
                    {lang.nativeName}
                  </Text>
                </div>
              </Option>
            ))}
          </Select>

          <Select
            value={chunkSize}
            onChange={setChunkSize}
            size="large"
            style={{ minWidth: 150 }}
            disabled={loading}
            placeholder="Chunk Size"
          >
            {CHUNK_SIZE_OPTIONS.map((size) => (
              <Option key={size} value={size}>
                Chunk Size: {size}
              </Option>
            ))}
          </Select>

          <Button
            type="primary"
            size="large"
            icon={<TranslationOutlined />}
            onClick={handleTranslate}
            loading={loading}
            disabled={!inputText.trim()}
          >
            {loading ? "Translating..." : "Translate"}
          </Button>
          <Button
            type="default"
            size="large"
            icon={<GlobalOutlined />}
            onClick={handleAutoTranslateAll}
            loading={loading}
            disabled={!inputText.trim()}
          >
            {loading ? "Processing..." : "Auto Translate All"}
          </Button>
          <Button 
            size="large"
            icon={<ClearOutlined />}
            onClick={handleClear}
            disabled={loading}
          >
            Clear
          </Button>
        </div>

        {(translationStats || error) && (
          <div style={{ marginBottom: '24px' }}>
            {translationStats && (
              <Alert
                message="Translation Complete"
                description={
                  <div>
                    <Text>
                      Translated {translationStats.translatedKeys} of {translationStats.totalKeys} fields 
                      in {translationStats.translationTime}ms
                    </Text>
                    {translationStats.excludedKeys > 0 && (
                      <>
                        <br />
                        <Text type="secondary" style={{ color: '#fa8c16' }}>
                          🚫 Excluded {translationStats.excludedKeys} keys (kept in English)
                        </Text>
                      </>
                    )}
                    <br />
                    <Text type="secondary">
                      Language: {selectedLanguage?.name} ({selectedLanguage?.nativeName})
                    </Text>
                    <br />
                    <Text type="secondary">
                      Processed in {translationStats.chunksProcessed} chunks (size: {translationStats.chunkSize})
                    </Text>
                    {translationStats.placeholdersFound > 0 && (
                      <>
                        <br />
                        <Text type="secondary" style={{ color: '#52c41a' }}>
                          🔒 Preserved {translationStats.placeholdersFound} placeholders
                        </Text>
                      </>
                    )}
                    {translationStats.dotsPreserved > 0 && (
                      <>
                        <br />
                        <Text type="secondary" style={{ color: '#52c41a' }}>
                          📍 Preserved trailing dots in {translationStats.dotsPreserved} strings
                        </Text>
                      </>
                    )}
                  </div>
                }
                type="success"
                showIcon
                icon={<CheckCircleOutlined />}
                closable
                onClose={() => setTranslationStats(null)}
                style={{ marginBottom: error ? '16px' : '0' }}
              />
            )}

            {error && (
              <Alert
                message="Translation Error"
                description={error}
                type="error"
                showIcon
                icon={<ExclamationCircleOutlined />}
                closable
                onClose={() => setError(null)}
              />
            )}
          </div>
        )}

        <Card 
          title={
            <Space>
              <ClearOutlined />
              <Text strong>Excluded Keys (Optional)</Text>
            </Space>
          }
          style={{ marginBottom: '24px' }}
        >
          <TextArea
            placeholder="Enter keys to exclude from translation, separated by commas. Example: TERMS_URL, PRIVACY_URL, API_KEY"
            value={excludedKeys}
            onChange={(e) => setExcludedKeys(e.target.value)}
            rows={3}
            disabled={loading}
            style={{ 
              fontFamily: 'Monaco, Consolas, monospace',
              resize: 'none'
            }}
          />
          <Text type="secondary" style={{ fontSize: '12px', marginTop: '8px', display: 'block' }}>
            These keys will remain in English in the output JSON
          </Text>
        </Card>

        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card 
              title={
                <Space>
                  <FileTextOutlined />
                  <Text strong>Input (English JSON)
                    <Text style={{color: 'red'}}>*</Text>
                  </Text>
                </Space>
              }
              style={{ height: '600px' }}
            >
              <TextArea
                placeholder='Enter JSON here, e.g., { "HELLO": "Hello...", "WELCOME": "Welcome {{name}} to our service..." }'
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                rows={20}
                disabled={loading}
                style={{ 
                  fontFamily: 'Monaco, Consolas, monospace',
                  height: '100%',
                  resize: 'none'
                }}
              />
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card 
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Space>
                    <GlobalOutlined />
                    <Text strong>
                      Output ({selectedLanguage?.name})
                    </Text>
                    {isProcessing && (
                      <Tag color="processing">Processing...</Tag>
                    )}
                  </Space>
                  {outputText && (
                    <Space>
                      <Button 
                        icon={<CopyOutlined />} 
                        onClick={handleCopy}
                        disabled={isProcessing}
                      >
                        Copy
                      </Button>
                      <Button 
                        icon={<DownloadOutlined />} 
                        onClick={handleExport}
                        type="primary"
                        disabled={isProcessing}
                        title={isProcessing ? "Please wait until all chunks are processed" : "Export JSON"}
                      >
                        Export JSON
                      </Button>
                    </Space>
                  )}
                </div>
              }
              style={{ height: '600px' }}
            >
              <div style={{ height: '100%' }}>
                <Spin spinning={loading && !outputText}>
                  <TextArea
                    placeholder="Translated JSON will appear here with preserved {{placeholders}} and trailing dots..."
                    readOnly
                    value={outputText}
                    rows={20}
                    style={{ 
                      height: '100%',
                      fontFamily: 'Monaco, Consolas, monospace',
                      resize: 'none'
                    }}
                  />
                </Spin>
              </div>
            </Card>
          </Col>
        </Row>

        <Card style={{ marginTop: '24px' }} title="Enhanced Features">
          <Row gutter={16}>
            <Col span={6}>
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Text strong style={{ color: '#1890ff', fontSize: '16px' }}>🔒 Placeholder Preservation</Text>
                <br />
                <Text type="secondary">
                  Keeps placeholders like {'{{'}{'{'}name{'}'}{'}'} intact
                </Text>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Text strong style={{ color: '#52c41a', fontSize: '16px' }}>📍 Dot Handling</Text>
                <br />
                <Text type="secondary">
                  Preserves trailing dots (...) in text
                </Text>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Text strong style={{ color: '#fa8c16', fontSize: '16px' }}>🚫 Key Exclusion</Text>
                <br />
                <Text type="secondary">
                  Exclude keys from translation
                </Text>
              </div>
            </Col>
            <Col span={6}>
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Text strong style={{ color: '#722ed1', fontSize: '16px' }}>⚡ Batch Processing</Text>
                <br />
                <Text type="secondary">
                  Configurable chunk sizes
                </Text>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default BhashiniService;